// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__22Gt6","detailsBorder":"styles_detailsBorder__GWpBN"};